import { render, staticRenderFns } from "./inventory-aging-report.vue?vue&type=template&id=5fc15cd6&"
import script from "./inventory-aging-report.vue?vue&type=script&lang=ts&"
export * from "./inventory-aging-report.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports